import { render, staticRenderFns } from "./payment-response.vue?vue&type=template&id=799454b4&scoped=true&"
import script from "./payment-response.vue?vue&type=script&lang=js&"
export * from "./payment-response.vue?vue&type=script&lang=js&"
import style0 from "./payment-response.vue?vue&type=style&index=0&id=799454b4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799454b4",
  null
  
)

export default component.exports